import { NAME, STORES } from '../../fields'

export const initialValues = {
  [NAME]: '',
  [STORES]: []
}
